import ApiService from "../../services/ApiService";

const WeeklyEmailService = {
    getTemplate: async (locale) => {
        const result = await ApiService.getData("/v1/weekly-email/template", {
            locale: locale || "en",
        });
        if (result && result.code === "FAILURE") {
            throw result.message || "Failed to load weekly email template";
        }
        return result;
    },

    save: async (body) => {
        const result = await ApiService.postData("/v1/weekly-email/template", body);
        if (result && result.code === "FAILURE") {
            throw result.message || "Failed to save weekly email template";
        }
        return result;
    },

    preview: async (body) => {
        const result = await ApiService.postData("/v1/weekly-email/preview", body);
        if (result && result.code === "FAILURE") {
            throw result.message || "Failed to preview weekly email";
        }
        return result;
    },

    listIssues: async () => {
        const result = await ApiService.getData("/v1/weekly-email/issues");
        if (result && result.code === "FAILURE") {
            throw result.message || "Failed to load weekly emails";
        }
        return Array.isArray(result) ? result : [];
    },

    createIssue: async () => {
        const result = await ApiService.postData("/v1/weekly-email/issues", {});
        if (result && result.code === "FAILURE") {
            throw result.message || "Failed to create weekly email";
        }
        return result;
    },

    getIssue: async (id) => {
        const result = await ApiService.getData(`/v1/weekly-email/issues/${id}`);
        if (result && result.code === "FAILURE") {
            throw result.message || "Failed to load weekly email";
        }
        return result;
    },

    refreshIssue: async (id) => {
        const result = await ApiService.postData(`/v1/weekly-email/issues/${id}/refresh`, {});
        if (result && result.code === "FAILURE") {
            throw result.message || "Failed to refresh weekly email";
        }
        return result;
    },

    confirmIssue: async (id) => {
        const result = await ApiService.postData(`/v1/weekly-email/issues/${id}/confirm`, {});
        if (result && result.code === "FAILURE") {
            throw result.message || "Failed to confirm weekly email";
        }
        return result;
    },

    reopenIssue: async (id) => {
        const result = await ApiService.postData(`/v1/weekly-email/issues/${id}/reopen`, {});
        if (result && result.code === "FAILURE") {
            throw result.message || "Failed to reopen weekly email";
        }
        return result;
    },

    removeIssue: async (id) => {
        const result = await ApiService.deleteData(`/v1/weekly-email/issues/${id}`);
        if (result && result.code === "FAILURE") {
            throw result.message || "Failed to remove weekly email";
        }
        return result;
    },

    sendSample: async (id) => {
        const result = await ApiService.postData(`/v1/weekly-email/issues/${id}/send-sample`, {});
        if (result && result.code === "FAILURE") {
            throw result.message || "Failed to send weekly email";
        }
        return result;
    },

    applyJigsaw: async (id, puzzleId) => {
        const result = await ApiService.postData(`/v1/weekly-email/issues/${id}/jigsaw`, { puzzleId });
        if (result && result.code === "FAILURE") {
            throw result.message || "Failed to apply jigsaw image";
        }
        return result;
    },
};

export default WeeklyEmailService;
